//React
import React from 'react';
import {
  Link
} from "react-router-dom";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

//Icon
import CloseIcon from '@material-ui/icons/Close';
import PartChargeIcon from './PartChargeIcon';


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      confirm: false,
  	}
  }


	render() {
    let contents;
    let button;
    if (this.props.checkBool === true) {
      if (this.props.checkType === 'free') {
        contents = (
          <div>
            <div  style={{margin:'10px', whiteSpace: 'pre-line'}}>
              {this.props.textareaText}
            </div>
          </div>
        )
        button = (
          <div align='center' style={{margin:'10px'}}>
            <Button
              variant="contained"
              color="primary"
              style={{minWidth:'200px'}}
              onClick={ () => this.props.submit('free') }
            >
              <span style={{fontSize:'1.4em'}}>送信する</span>
            </Button>
          </div>
        )
      }
      else {
        contents = (
          <div>
            <div  style={{margin:'10px', whiteSpace: 'pre-line'}}>
              {this.props.textareaText}
            </div>
          </div>

        )
        button = (
          <div align='center' style={{margin:'10px'}}>
            <Button
              variant="contained"
              color="primary"
              style={{minWidth:'200px'}}
              onClick={ () => this.props.submit('approach-pending') }
            >
              <div>
                <div style={{fontSize:'0.9em'}}>ガイドラインのチェック後に<br />12時間以内に送信されます</div>
                <div style={{fontSize:'1.4em'}}>無料メールを送信する</div>
              </div>
            </Button>
          </div>
        )
      }
    }
    else {
      if (this.props.checkType === 'noCharge') {
        contents = (
          <div>
            <div align='center' style={{padding:'5px'}}>無料メールはこれ以上送れません</div>

            <div align='center' style={{padding:'5px'}}>
              <Button
                variant="outlined"
                onClick={ () => this.props.helpOpen('id',474) }
              >
                無料メールの上限について
              </Button>
            </div>
            <PartChargeIcon/>
            {
              (this.props.checkLeft > 0) && (
                <div>
                  <div align='center' style={{padding:'5px'}}>
                    追加で証明書を提出いただくと<br />
                    さらに無料メールが送れます
                  </div>
                  <div align='center' style={{padding:'5px'}}>
                    <Link to="/my/proof/">
                      <Button
                        variant="contained"
                        color='primary'
                        style={{minWidth:'200px'}}
                      >
                        <span>証明書を申請する</span>
                      </Button>
                    </Link>
                  </div>
                </div>
              )
            }
          </div>
        )

      }
      else if (this.props.checkType === 'noProof') {
        if (this.props.my.profile.userdata_sex === 'men') {
          contents = (
            <div>
              <h2 align='center'>
                本人証明が申請されていない為<br />
                メールは送信できません
              </h2>
              <div>
                提出いただくと無料メールが送信できます
              </div>
            </div>
          )
        }
        else if (this.props.my.profile.userdata_sex === 'women') {
          contents = (
            <div>
              <h2 align='center'>
                本人証明が申請されていない為<br />
                メールは送信できません
              </h2>
              <div >
                本人証明を申請いただくと<br/>すべて無料でご利用いただけます。
              </div>
            </div>
          )
        }
        button = (
          <div align='center' style={{margin:'10px'}}>
            <Link to="/my/proof/person">
              <Button
                variant="contained"
                color='secondary'
                style={{minWidth:'200px'}}
              >
                <div>
                  <div style={{fontSize:'1.4em'}}>本人証明を申請する</div>
                  <div>1分ほどで簡単に申請できます</div>
                </div>
              </Button>
            </Link>
          </div>
        )
      }
      else {
        contents = (
          <div>
            <h4>メールは送れません</h4>
            {this.props.checkComment}
          </div>
        )
      }
    }

		return (
      <Dialog
        open={this.props.open}
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            メール送信
          </div>
          <IconButton
            onClick={ () => this.props.close() }
          >
            <CloseIcon/>
          </IconButton>
        </div>
        <DialogContent style={{padding:'10px'}}>
          { contents }
        </DialogContent>
        {button}
      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
